export const urlBlog = process.env.REACT_APP_WEBSITE_BLOG;
